// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"~views/colors.css\"","easilGrayLight":"#BDC0C2","inputTransparent":"style_inputTransparent__3ScaD"};